import { createStyles, makeStyles } from '@material-ui/styles';
const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
